import React from "react";

export default class Month extends React.Component {
  render() {
    const { monthData, style, isCurrentMonth, children, name } = this.props;
    let gridTemplateRows = "1fr";
    for (let i = 1; i < monthData.numWeeks; i++) {
      gridTemplateRows += " 1fr";
    }
    return (
      <div className="Month" style={style}>
        {!isCurrentMonth && <div className="month-name">{name}</div>}
        <div
          className="days-container"
          style={{ gridTemplateRows: gridTemplateRows }}
          data-cy={"days-container-" + monthData.name + "-" + monthData.year}
        >
          {children}
        </div>
      </div>
    );
  }
}
